<!--
 * @Author:
 * @LastEditTime: 2022-04-28 16:33:00
 * @Description:
-->
<template>
  <el-card class="h-full">
    <div class="flex flex-col h-full">
      <div class="flex flex-row-reverse mb-20px">
        <el-button v-show="isEdit" class="ml-15px" size="small" @click="isEdit = false"
          >返回</el-button
        >
        <el-button size="small" v-show="!isEdit" class="ml-15px" type="primary" @click="editApi()"
          >编辑</el-button
        >
        <el-button
          v-show="isEdit"
          type="primary"
          class="ml-10px"
          @click="saveSettings"
          :loading="savaLoading"
          >保存</el-button
        >
      </div>
      <div class="overflow-y-auto flex-1">
        <el-collapse v-model="collapseActiveName">
          <el-form
            ref="form"
            v-loading="loading"
            :disabled="!isEdit"
            inline
            label-width="260px"
            :model="formData"
            :hide-required-asterisk="!isEdit"
            :show-message="!!isEdit"
            label-position="right"
            :validate-on-rule-change="false"
          >
            <el-collapse-item
              :title="info.title"
              :name="index + 1"
              v-for="(info, index) in infoList"
              :key="index"
            >
              <el-form-item
                class="w-1/2 !mr-0"
                :label="`${form.name}:`"
                :prop="form.file"
                v-for="(form, formIndex) in info.formList"
                :key="formIndex"
                :rules="form.rules || []"
              >
                <el-select
                  v-if="form.type === 'select'"
                  v-model="formData[form.file]"
                  :placeholder="isEdit ? `请输入${form.name}` : ''"
                >
                  <el-option
                    v-for="item in safetyLevelOption"
                    :key="item.code"
                    :value="item.code"
                    :label="item.displayName"
                  ></el-option>
                </el-select>
                <el-input-number
                  v-else-if="form.type === 'number'"
                  :max="10000"
                  :disabled="!isEdit"
                  :min="0"
                  v-model="formData[form.file]"
                  :placeholder="isEdit ? `请输入` : ''"
                ></el-input-number>
              </el-form-item>

              <p class="mt-20px" v-if="index === 1 && !isEdit">
                温馨提示：上报隐患获得积分需隐患开始整改上报人才能获得积分，隐患按期整改验收通过后，整改负责人才能获得积分
              </p>
              <p class="mt-20" v-if="index === 1 && isEdit">
                温馨提示：上报隐患获得积分需隐患治理流程结束后，上报人才能获得积分
              </p>
            </el-collapse-item>
          </el-form>
        </el-collapse>
      </div>
    </div>
  </el-card>
</template>

<script>
import { AutomaticCheckConfigurationApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'

const automaticCheckConfigurationApi = new AutomaticCheckConfigurationApi()

export default {
  name: 'auto-check-config',
  data() {
    return {
      loading: false,
      savaLoading: false,
      isEdit: false,
      formData: {
        assessmentCycle: null,
        completionCredit: 0,
        reportCriticalHazardPoints: 0,
        reportGeneralHazardPoints: 0,
        hiddenDangerRectificationPersonPoints: 0,
        taskOverdueMinusPoints: 0,
        tasksAreHeadLosePoints: 0,
      },
      collapseActiveName: [1, 2, 3, 4, 5],
      infoList: [
        {
          title: '考核周期设置',
          formList: [
            {
              name: '考核自动生成周期',
              type: 'select',
              file: 'assessmentCycle',
              rules: [{ required: true, message: '考核自动生成周期' }],
            },
          ],
        },
        {
          title: '积分增加项目设置',
          formList: [
            {
              name: '按期隐患排查任务增加积分',
              type: 'number',
              file: 'completionCredit',
              rules: [{ pattern: /^[+]{0,1}(\d+)$/, message: '请输入正整数' }],
            },
            {
              name: '上报重大隐患获得积分',
              type: 'number',
              file: 'reportCriticalHazardPoints',
              rules: [{ pattern: /^[+]{0,1}(\d+)$/, message: '请输入正整数' }],
            },
            {
              name: '上报一般隐患获得积分',
              type: 'number',
              file: 'reportGeneralHazardPoints',
              rules: [{ pattern: /^[+]{0,1}(\d+)$/, message: '请输入正整数' }],
            },
            {
              name: '隐患按期整改验收通过负责人增加积分',
              type: 'number',
              file: 'hiddenDangerRectificationPersonPoints',
              rules: [{ pattern: /^[+]{0,1}(\d+)$/, message: '请输入正整数' }],
            },
          ],
        },
        {
          title: '积分减少项目设置',
          formList: [
            {
              name: '隐患排查任务超期未排查减少积分',
              type: 'number',
              file: 'taskOverdueMinusPoints',
              rules: [{ pattern: /^[+]{0,1}(\d+)$/, message: '请输入正整数' }],
            },
            {
              name: '隐患超期未整改减少整改负责人积分',
              type: 'number',
              file: 'tasksAreHeadLosePoints',
              rules: [{ pattern: /^[+]{0,1}(\d+)$/, message: '请输入正整数' }],
            },
          ],
        },
      ],
      safetyLevelOption: [
        {
          code: 0,
          displayName: '月',
        },
        {
          code: 1,
          displayName: '季',
        },
        {
          code: 2,
          displayName: '年',
        },
      ],
    }
  },
  methods: {
    async saveSettings() {
      this.$confirm('是否保存当前设置！', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      })
        .then(async () => {
          this.$refs.form.validate(async (valid) => {
            if (valid) {
              this.savaLoading = true
              if (this.formData.id) {
                const [err, res] = await automaticCheckConfigurationApi.update({
                  id: this.formData.id,
                  body: this.formData,
                })
                if (!err) {
                  this.$message.success('保存成功')
                  this.isEdit = false
                }
              } else {
                const [err, res] = await automaticCheckConfigurationApi.create({
                  body: this.formData,
                })
                if (!err) {
                  this.$message.success('保存成功')
                  this.isEdit = false
                }
              }
              this.savaLoading = false
            }
          })
        })
        .catch(() => {})
    },
    editApi(row) {
      this.$refs.form.clearValidate()
      this.loading = true
      setTimeout(() => {
        this.isEdit = true
        this.loading = false
      }, 200)
    },
    async getInfo() {
      this.loading = true
      const [err, res] = await automaticCheckConfigurationApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err && res.items.length > 0) {
        this.formData = { ...res.items[0] }
        this.loading = false
      } else {
        this.formData = this.$options.data().formData
        this.loading = false
      }
    },
  },
  created() {
    this.getInfo()
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}

::v-deep .el-select {
  width: 187px;
}
</style>
